export const spinner = {
    /**
     * Show a spinner overlay with text.
     * @param {string} text - The text to display below the spinner (default: "Loading...")
     */
    show(text = "Loading...") {
        // Create a new div element for the overlay
        const overlay = document.createElement("div");
        overlay.id = 'spinner-overlay';
        overlay.style.position = "fixed";
        overlay.style.display = "flex";
        overlay.style.flexDirection = "column";
        overlay.style.justifyContent = "center";
        overlay.style.alignItems = "center";
        overlay.style.top = "0";
        overlay.style.left = "0";
        overlay.style.width = "100%";
        overlay.style.height = "100%";
        overlay.style.backgroundColor = "rgba(255, 255, 255, 0.95)";
        overlay.style.zIndex = "9999";

        // Create the spinner container
        const spinnerContainer = document.createElement("div");
        spinnerContainer.style.position = "relative";
        spinnerContainer.style.width = "80px";
        spinnerContainer.style.height = "80px";

        // Create the segments for the spinner - 8 rectangles
        for (let i = 0; i < 8; i++) {
            const segment = document.createElement("div");
            
            // Set positioning
            segment.style.position = "absolute";
            segment.style.width = "7px";
            segment.style.height = "20px";
            segment.style.backgroundColor = "#2D2D2D";
            segment.style.borderRadius = "900px";
            segment.style.left = "36.5px"; // Center horizontally
            segment.style.top = "0";
            segment.style.transformOrigin = "3.5px 40px"; // Pivot from the center of the spinner
            segment.style.transform = `rotate(${i * 45}deg)`; // 360 / 8 = 45 degrees per segment
            
            // Set opacity - create a gradient effect
            segment.style.opacity = String(0.2 + (i / 8 * 0.8));
            
            spinnerContainer.appendChild(segment);
        }

        // Set animation rotation
        spinnerContainer.style.animation = "spin 1.2s linear infinite";
        
        // Create the text element
        const textElement = document.createElement("div");
        textElement.id = 'spinner-text';
        textElement.textContent = text;
        textElement.style.marginTop = "30px";
        textElement.style.fontFamily = "Arial, sans-serif";
        textElement.style.fontSize = "24px";
        textElement.style.color = "#000";
        textElement.style.textAlign = "center";

        // Add the spinner and text to the overlay
        overlay.appendChild(spinnerContainer);
        overlay.appendChild(textElement);

        // Append the overlay to the body
        document.body.appendChild(overlay);

        // Add the spin animation
        const style = document.createElement('style');
        style.textContent = `
        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }
        `;
        document.head.appendChild(style);
    },

    /**
     * Update the spinner text.
     * @param {string} text - The new text to display
     */
    updateText(text) {
        const textElement = document.getElementById('spinner-text');
        if (textElement) {
            textElement.textContent = text;
        }
    },

    /**
     * Hide the spinner overlay.
     */
    hide() {
        // Find the overlay by id and remove it
        const overlay = document.getElementById('spinner-overlay');
        if (overlay) {
            document.body.removeChild(overlay);
        }
    }
};